


















import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
    name: "FavoritesSwitcher"
})
export default class FavoritesSwitcher extends Vue {
    @Prop() value: boolean;

    get accentColor() {
        return this.value ? '#D0D0D0' : '#ffffff'
    }
}

